export default __webpack_public_path__ + "static/media/sevenplus.db3ca945.png";